<template>
    <div class="form-edit-page">
        <div class="page-header">
            <h1>Solicitação de Registro de Produtos e Rótulos</h1>
            <p>
                Protocolo online para solicitação, alteração, cancelamento e acompanhamento
                de registros de produtos e rótulos pelo estabelecimento.
            </p>
        </div>

        <ProdutoRotuloSolicitacaoForm
            :ls-estabelecimentos="lsEstabelecimentos"
            :ls-classificacoes="lsClassificacoes"
            @salvar="adicionarSolicitacao"
        />

        <div class="row-space"></div>

        <ProdutoRotuloSolicitacaoLista
            :ls-dados="lsSolicitacoes"
            :item-selecionado-id="solicitacaoSelecionada?.id || 0"
            @selecionar="selecionarSolicitacao"
        />

        <div class="row-space"></div>

        <ProdutoRotuloSolicitacaoDetalhe
            v-if="solicitacaoSelecionada"
            :solicitacao="solicitacaoSelecionada"
        />
    </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import ProdutoRotuloSolicitacaoForm from './ProdutoRotuloSolicitacaoForm_29.vue'
import ProdutoRotuloSolicitacaoLista from './ProdutoRotuloSolicitacaoLista_29.vue'
import ProdutoRotuloSolicitacaoDetalhe from './ProdutoRotuloSolicitacaoDetalhe_29.vue'

const lsEstabelecimentos = ref([
    { id: 1, nome: 'Frigorífico Boi do Vale Ltda', cnpj: '12.345.678/0001-90', nmsim: 'SIM 001' },
    { id: 2, nome: 'Laticínios Serra Azul', cnpj: '98.765.432/0001-10', nmsim: 'SIM 014' },
    { id: 3, nome: 'Apiário Doce Campo', cnpj: '11.222.333/0001-55', nmsim: 'SIM 022' }
])

const lsClassificacoes = ref([
    'Carnes e derivados',
    'Leite e derivados',
    'Mel e produtos apícolas',
    'Ovos e derivados',
    'Pescado e derivados'
])

const lsSolicitacoes = ref([
    {
        id: 1,
        protocolo: 'PRD-2026-0001',
        estabelecimentoId: 1,
        estabelecimentoNome: 'Frigorífico Boi do Vale Ltda',
        tipoSolicitacao: 'NOVO_REGISTRO',
        classificacao: 'Carnes e derivados',
        produtoNome: 'Linguiça Colonial Defumada',
        produtoVersao: '1.0',
        status: 'EM_ANALISE',
        dataSolicitacao: '2026-03-10',
        responsavel: 'Carlos Henrique',
        observacoes: 'Primeira solicitação do produto para análise do rótulo.',
        anexos: [
            { id: 1, nome: 'rotulo_linguica_colonial.pdf', tipo: 'Rótulo' },
            { id: 2, nome: 'memorial_descritivo.pdf', tipo: 'Memorial' }
        ],
        historico: [
            { data: '2026-03-10 09:15', evento: 'Protocolo gerado automaticamente pelo estabelecimento.' },
            { data: '2026-03-11 14:40', evento: 'Solicitação recebida pelo serviço de inspeção.' },
            { data: '2026-03-12 10:05', evento: 'Processo encaminhado para análise técnica.' }
        ],
        pendencias: []
    },
    {
        id: 2,
        protocolo: 'PRD-2026-0002',
        estabelecimentoId: 2,
        estabelecimentoNome: 'Laticínios Serra Azul',
        tipoSolicitacao: 'ALTERACAO',
        classificacao: 'Leite e derivados',
        produtoNome: 'Queijo Colonial Tradicional',
        produtoVersao: '2.1',
        status: 'COM_PENDENCIA',
        dataSolicitacao: '2026-03-08',
        responsavel: 'Fernanda Alves',
        observacoes: 'Alteração de arte do rótulo e revisão de informações nutricionais.',
        anexos: [
            { id: 1, nome: 'rotulo_queijo_colonial_v2.pdf', tipo: 'Rótulo' },
            { id: 2, nome: 'ficha_tecnica_queijo.pdf', tipo: 'Ficha Técnica' }
        ],
        historico: [
            { data: '2026-03-08 08:20', evento: 'Solicitação de alteração registrada.' },
            { data: '2026-03-09 16:10', evento: 'Análise inicial concluída.' },
            { data: '2026-03-10 11:30', evento: 'Pendência emitida: ajustar denominação de venda no rótulo.' }
        ],
        pendencias: [
            { id: 1, descricao: 'Corrigir a denominação de venda conforme padrão legal.' },
            { id: 2, descricao: 'Reenviar o arquivo do rótulo em PDF com melhor resolução.' }
        ]
    },
    {
        id: 3,
        protocolo: 'PRD-2026-0003',
        estabelecimentoId: 3,
        estabelecimentoNome: 'Apiário Doce Campo',
        tipoSolicitacao: 'CANCELAMENTO',
        classificacao: 'Mel e produtos apícolas',
        produtoNome: 'Mel Silvestre Bisnaga 500g',
        produtoVersao: '1.4',
        status: 'APROVADO',
        dataSolicitacao: '2026-03-05',
        responsavel: 'João Pedro Souza',
        observacoes: 'Solicitação de cancelamento do registro por descontinuidade da linha.',
        anexos: [
            { id: 1, nome: 'requerimento_cancelamento.pdf', tipo: 'Requerimento' }
        ],
        historico: [
            { data: '2026-03-05 13:00', evento: 'Solicitação de cancelamento protocolada.' },
            { data: '2026-03-06 09:20', evento: 'Processo analisado pela equipe técnica.' },
            { data: '2026-03-07 15:45', evento: 'Cancelamento aprovado e cadastro interno atualizado.' }
        ],
        pendencias: []
    }
])

const idSelecionado = ref(1)

const solicitacaoSelecionada = computed(() => {
    return lsSolicitacoes.value.find(item => item.id === idSelecionado.value) || null
})

function selecionarSolicitacao(item) {
    idSelecionado.value = item.id
}

function adicionarSolicitacao(dados) {
    const novoId = lsSolicitacoes.value.length
        ? Math.max(...lsSolicitacoes.value.map(x => x.id)) + 1
        : 1

    const numeroSequencial = String(novoId).padStart(4, '0')

    const novaSolicitacao = {
        id: novoId,
        protocolo: `PRD-2026-${numeroSequencial}`,
        estabelecimentoId: Number(dados.estabelecimentoId),
        estabelecimentoNome: dados.estabelecimentoNome,
        tipoSolicitacao: dados.tipoSolicitacao,
        classificacao: dados.classificacao,
        produtoNome: dados.produtoNome,
        produtoVersao: dados.produtoVersao,
        status: 'EM_ANALISE',
        dataSolicitacao: new Date().toISOString().slice(0, 10),
        responsavel: dados.responsavel,
        observacoes: dados.observacoes,
        anexos: dados.anexos || [],
        historico: [
            {
                data: new Date().toLocaleString('pt-BR'),
                evento: 'Protocolo gerado automaticamente pelo estabelecimento.'
            }
        ],
        pendencias: []
    }

    lsSolicitacoes.value.unshift(novaSolicitacao)
    idSelecionado.value = novoId
}
</script>

<style scoped>
.form-edit-page {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    background: #f7f8fa;
}

.page-header {
    background: #ffffff;
    border: 1px solid #dfe4ea;
    border-radius: 10px;
    padding: 18px;
}

.page-header h1 {
    margin: 0 0 8px 0;
    font-size: 22px;
    color: #1f2937;
}

.page-header p {
    margin: 0;
    color: #4b5563;
    line-height: 1.5;
}

.row-space {
    height: 4px;
}
</style>